<div class="main-container" data-cy="ada-parameters-container">
  <div class="section-header" data-cy="ada-parameters-header">
    <div class="section-header-title" data-cy="ada-parameters-title">ADA form parameters</div>
  </div>
  <div style="display: inline-flex; margin:0" data-cy="ada-parameters-diagnosis-code-qualifier">
    <div style="width: 300px; margin:0" data-cy="ada-parameters-diagnosis-code-qualifier-label-container">
      <mat-label style="width: 100%" data-cy="ada-parameters-diagnosis-code-qualifier-label">
        34 Diagnosys Code List Qualifier:
      </mat-label>
    </div>
    <div style="width: 125px; margin:0" data-cy="ada-parameters-diagnosis-code-qualifier-a-container">
        <mat-form-field style="width: 125px" class="example-full-width" appearance="outline" data-cy="ada-parameters-diagnosis-code-qualifier-a-field">
          <input matInput [(ngModel)]="reportADAParams.ADAParameters.diagCodeListQualifierA" name="diagCodeListQualifierA" autocomplete="off" maxlength="2" va data-cy="ada-parameters-diagnosis-code-qualifier-a-input">
        </mat-form-field>
    </div>
    <div style="width: 125px; margin:0" data-cy="ada-parameters-diagnosis-code-qualifier-b-container">
      <mat-form-field class="example-full-width" style="width: 125px" appearance="outline" data-cy="ada-parameters-diagnosis-code-qualifier-b-field">
        <input matInput [(ngModel)]="reportADAParams.ADAParameters.diagCodeListQualifierB" autocomplete="off" maxlength="2" data-cy="ada-parameters-diagnosis-code-qualifier-b-input">
      </mat-form-field>
    </div>
  </div>
  <div style="display: inline-flex;margin:0 " data-cy="ada-parameters-diagnosis-code-primary-a">
    <div style="width: 280px; text-align: left  " data-cy="ada-parameters-diagnosis-code-primary-label-container">
      <mat-label style="width: 270px" data-cy="ada-parameters-diagnosis-code-primary-label">
        34.a Diagnosys Codes:
        (Primary Diagnosys in "A")
      </mat-label>
    </div>
    <div style="width: 270px; text-align: right" data-cy="ada-parameters-diagnosis-code-a-container">
      <span data-cy="ada-parameters-diagnosis-code-a-label">A </span>
      <mat-form-field style="width: 250px" class="example-full-width" appearance="outline" data-cy="ada-parameters-diagnosis-code-a-field">
        <input matInput [(ngModel)]="reportADAParams.ADAParameters.diagCodePrimA" autocomplete="off" maxlength="3" data-cy="ada-parameters-diagnosis-code-a-input">
      </mat-form-field>
    </div>
  </div>
  <div style="display: inline-block; width: 550px; text-align: right; margin:0 " data-cy="ada-parameters-diagnosis-codes-bcd">
    <div style="width: 280px; float: right " data-cy="ada-parameters-diagnosis-code-b-container">
      <span data-cy="ada-parameters-diagnosis-code-b-label">B </span>
      <mat-form-field style="width: 250px" class="example-full-width" appearance="outline" data-cy="ada-parameters-diagnosis-code-b-field">
        <input matInput [(ngModel)]="reportADAParams.ADAParameters.diagCodePrimB" autocomplete="off" maxlength="3" data-cy="ada-parameters-diagnosis-code-b-input">
      </mat-form-field>
    </div>
    <div style="width: 280px; float: right" data-cy="ada-parameters-diagnosis-code-c-container">
      <span data-cy="ada-parameters-diagnosis-code-c-label">C </span>
      <mat-form-field style="width: 250px" class="example-full-width" appearance="outline" data-cy="ada-parameters-diagnosis-code-c-field">
        <input matInput [(ngModel)]="reportADAParams.ADAParameters.diagCodePrimC" autocomplete="off" maxlength="3" data-cy="ada-parameters-diagnosis-code-c-input">
      </mat-form-field>
    </div>
    <div style="width: 280px; float: right" data-cy="ada-parameters-diagnosis-code-d-container">
      <span data-cy="ada-parameters-diagnosis-code-d-label">D </span>
      <mat-form-field style="width: 250px" class="example-full-width" appearance="outline" data-cy="ada-parameters-diagnosis-code-d-field">
        <input matInput [(ngModel)]="reportADAParams.ADAParameters.diagCodePrimD" autocomplete="off" maxlength="3" data-cy="ada-parameters-diagnosis-code-d-input">
      </mat-form-field>
    </div>
  </div>
  <div style="display: inline-block; width: 550px; text-align: left; margin:0 " data-cy="ada-parameters-remarks">
    <div style="width: 280px; float: left" data-cy="ada-parameters-remarks-label-container">
      <mat-label data-cy="ada-parameters-remarks-label">35. Remarks</mat-label>
    </div>
    <mat-form-field class="example-full-width" style="width: 550px" appearance="outline" data-cy="ada-parameters-remarks-field">
      <textarea matInput [(ngModel)]="reportADAParams.ADAParameters.remarks" autocomplete="off" data-cy="ada-parameters-remarks-input"></textarea>
    </mat-form-field>
  </div>
  <div style="flex: 1; text-align: right; padding-right:10px" data-cy="ada-parameters-buttons">
    <button style="margin-right: 12px;" class="tdo-button warn" (click)="closeRef()" data-cy="ada-parameters-cancel-button">Cancel</button>
    <button class="tdo-button primary-accent" (click)="SaveClaimStatus()" data-cy="ada-parameters-ok-button">
      Ok
    </button>
  </div>
</div>
